import { FC } from 'react';

import { ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';

import * as S from './styles';

const ChatIcon = ICONS.MESSAGE;

interface IChatLauncherProps {
  onClick(): void;
}

const ChatLauncher: FC<IChatLauncherProps> = ({ onClick }) => {
  const { t } = useLocale('webchat');

  return (
    <S.Container
      type="button"
      aria-label={t('Open the chat')}
      title={t('Open the chat')}
      onClick={onClick}
    >
      <ChatIcon />
    </S.Container>
  );
};

export default ChatLauncher;
